var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { activeItemVar } from "core/state";
import { Env } from "core/utils";
import React, { useEffect, useRef, useState } from "react";
import styled, { css } from "styled-components";
import { BoxCover } from "../BoxCover";
import { getTrackingData } from "../BoxCover/Details";
import { DividerBoxCover } from "../DividerBoxCover";
import { Grid } from "../Grid";
import { HoverCard } from "../HoverCard";
import { Modal } from "../Modal";
export var ExpandableGrid = function (_a) {
    var title = _a.title, items = _a.items, className = _a.className, props = __rest(_a, ["title", "items", "className"]);
    var gridRef = useRef(null);
    var _b = useState(null), isModalOpen = _b[0], setModalOpen = _b[1];
    var _c = useState(null), isShowing = _c[0], setIsShowing = _c[1];
    var _d = useState(), hoverPosition = _d[0], setHoverPostion = _d[1];
    var timer;
    var onKeyEnter = function (event, data, ref) {
        if (ref.current) {
            if (event.key === "Enter" || event.key === " ") {
                event.preventDefault(); // Prevent scrolling when pressing space
                setHoverPostion({
                    left: Number(event.currentTarget.getBoundingClientRect().left) -
                        parseInt(window.getComputedStyle(ref.current).paddingLeft, 10) -
                        parseInt(window.getComputedStyle(ref.current).marginLeft, 10),
                    top: event.currentTarget.getBoundingClientRect().y,
                });
                setIsShowing(data);
            }
        }
    };
    var mouseEnter = function (data, ref) {
        timer = setTimeout(function () {
            var _a, _b, _c, _d, _e, _f;
            if (ref.current) {
                var height = void 0;
                if (((_b = (_a = props.containerRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().y) &&
                    ((_c = ref.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect().y)) {
                    height =
                        ((_d = ref.current) === null || _d === void 0 ? void 0 : _d.getBoundingClientRect().y) -
                            ((_f = (_e = props.containerRef) === null || _e === void 0 ? void 0 : _e.current) === null || _f === void 0 ? void 0 : _f.getBoundingClientRect().y);
                }
                setHoverPostion({
                    left: ref.current.offsetLeft,
                    top: height,
                });
                setIsShowing(data);
            }
        }, 300);
    };
    var mouseLeave = function () {
        clearTimeout(timer);
    };
    var renderItem = function (options, index) {
        switch (options.data.type) {
            case "divider":
                return (React.createElement(DividerBoxCover, { key: "divider-".concat(options.data.letter) }, options.data.letter));
            case "content":
                return (React.createElement(BoxCover.View, { onClick: function () {
                        return Env.isTouch &&
                            options.data.type === "content" &&
                            setModalOpen(options.data.item);
                    }, url: !Env.isTouch && options.data.item.slug
                        ? options.data.item.slug
                        : undefined, details: options.data.item, mouseEnter: mouseEnter, mouseLeave: mouseLeave, onKeyEnter: onKeyEnter, trackingData: getTrackingData(options.data.item, options.listName, index + 1), key: options.data.item.uuid + '-grid' }));
        }
    };
    useEffect(function () {
        var callback = function () {
            activeItemVar(null);
        };
        window.addEventListener("resize", callback);
        return function () { return window.removeEventListener("resize", callback); };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { className: className, "data-component": props["data-component"], title: title, ref: gridRef }, items.map(function (item, index) { return (React.createElement(React.Fragment, { key: item.id }, renderItem(item, index))); })),
        isShowing && !Env.isTouch && (React.createElement(StyledHoverCard, { laneName: "all-programs", className: className, "$hoverPosition": hoverPosition, setShowing: setIsShowing, item: isShowing })),
        Env.isTouch && isModalOpen && (React.createElement(Modal, { isModalOpen: isModalOpen, setModalOpen: setModalOpen },
            React.createElement(HoverCard, { laneName: "all-programs", item: isModalOpen })))));
};
export var StyledHoverCard = styled(HoverCard)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  z-index: 8;\n  transform: translate(-30%, 0);\n\n  ", "\n"], ["\n  position: absolute;\n  z-index: 8;\n  transform: translate(-30%, 0);\n\n  ", "\n"])), function (props) {
    return props.$hoverPosition && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      top: calc(", "px - 1.5rem);\n      left: ", "px;\n    "], ["\n      top: calc(", "px - 1.5rem);\n      left: ", "px;\n    "])), props.$hoverPosition.top, props.$hoverPosition.left);
});
var templateObject_1, templateObject_2;
